/*
 * The gate for sleep sounds: one rewarded video unlocks them for the rest of the session (until the app
 * is closed); the lifetime unlock skips it. The flag is deliberately in memory only.
 */
let unlockedThisSession = false;

export const sleepUnlocked = (): boolean => unlockedThisSession;

/** Resolves true when the sounds may play. `request` is the app's video gate (`useAds().requestUnlock`). */
export const ensureSleepUnlocked = async (
    adFree: boolean,
    request: () => Promise<boolean>
): Promise<boolean> => {
    if (adFree || unlockedThisSession) return true;
    if (!(await request())) return false;
    unlockedThisSession = true;
    return true;
};

export const resetSleepGate = (): void => {
    unlockedThisSession = false;
};
